var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$store.state.player.isStarted)?_c('md-button',{staticClass:"md-info",on:{"click":_vm.capture}},[_vm._v("take a snapshot")]):_vm._e(),_c('div',{staticClass:"row md-card-body",attrs:{"id":"storesnapshot"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }